const urls = {
    apiBase: window.location.protocol + '//' + window.location.host + '/api',
};

export default urls;